import { nanoid } from 'nanoid';

import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import { NotFoundError, RedirectError } from '#src/shared/error';

import type { ImpactStoryDataQuery, ImpactStoryDataQueryVariables } from './api.graphql';
import { ImpactStoryData } from './api.graphql';

type ImpactStoryType = NonNullable<ImpactStoryDataQuery['impactStory']>;

export type ImpactStoryPageData = {
	petition: NonNullable<ImpactStoryDataQuery['petition']>;
	featureConfig: {
		story: ImpactStoryType;
	};
	aiSapId: string;
};

export async function getImpactStoryPageData(
	{ gql: { fetch } }: UtilityContext,
	slug: string,
): Promise<ImpactStoryPageData> {
	const { data } = await fetch<ImpactStoryDataQuery, ImpactStoryDataQueryVariables>({
		query: ImpactStoryData,
		variables: {
			slugOrId: slug,
		},
		rejectOnError: true,
	});

	if (!data.petition) {
		throw new NotFoundError();
	}

	if (!data.impactStory) {
		throw new RedirectError({ url: `/p/${encodeURIComponent(slug)}`, reason: 'impact-story-not-available' });
	}

	if (slug !== data.petition.slug) {
		throw new RedirectError({
			url: `/impact-stories/${data.petition.slug}`,
			permanent: true,
			forwardQueryParams: true,
		});
	}

	return {
		petition: data.petition,
		featureConfig: {
			story: data.impactStory,
		},
		aiSapId: nanoid(),
	};
}
